export const passwordTypeValidator = (value) => {
    if (!value || value === '') return false;

    // Valid password types are 'custom' and 'default'
    const validTypes = ['custom', 'default'];
    return validTypes.includes(value);
};
